var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from "react";
import { asThemeConsumer } from "../../../../theme/Theme";
import { Input } from "../../05-atoms/Input";
import { Select } from "../../05-atoms/Select";
import { fieldValidationIcon, fieldValidationMessage } from "./Field.utils";
import { FormGroup } from "./Group";
/**
 *
 * @param props
 */
var FormFieldComp = function (props) { return (React.createElement(FormGroup, __assign({}, props),
    !props.options
        ?
            React.createElement(Input, { placeholder: props.placeholder, value: props.value, onChange: !!props.readonly ? undefined : props.onChange, type: props.type || "text", disabled: !!props.readonly ? true : props.onChange ? false : true, min: props.min, max: props.max, required: props.required, title: props.title, asSummary: props.asSummary, popperPlacement: props.popperPlacement, minDate: props.minDate, maxDate: props.maxDate })
        : React.createElement(Select, { required: props.required, placeholder: props.placeholder, unsorted: props.unsorted, value: props.value, values: props.values, onChange: !!props.readonly ? undefined : props.onChange, options: props.options, defaultValue: undefined, disabled: !!props.readonly ? true : props.onChange ? false : true, multiple: props.multiple }),
    fieldValidationMessage(props) &&
        (React.createElement("div", { className: "scl-o-form__info" },
            React.createElement("div", { className: "scl-o-form__info-text" }, fieldValidationMessage(props)),
            React.createElement("div", { className: "scl-o-form__info-icon" }, fieldValidationIcon(props)))))); };
/**
 *
 */
export var FormField = asThemeConsumer(FormFieldComp);
